const alt = ' | Omida VLS'
export default alt
